import { Pipe } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { PrefixedTranslatePipe } from './prefixed-translate.pipe'

@Pipe({
  name: 'contactType',
  pure: false
})
export class ContactTypePipe extends PrefixedTranslatePipe {

  constructor (translatePipe: TranslatePipe) {
    super(translatePipe, 'CONTACT_TYPES.')
  }
}
